<template>
    <div class="modal_size notice_size">
        <a href="javascript:" class="ui_close" type="button" @click="closePopup">
            <span class="sr_only">popup close</span>
        </a>

        <dl class="modal_content">
            <dt class="notice ellipsis">
                <i>{{$t('TITLE.NOTICE.POPUP')}}</i>
            </dt>
            <dd>
                <dl class="notice_view">
                    <dt>{{ getNoticeTitle }}</dt>
                    <dd v-html="view.content">
                    </dd>
                </dl>

                <div class="attachment_view">
                    <innorix-download
                        v-if="fileList.length > 0"
                        :id="seq"
                        :name="seq" 
                        :uploadId="seq"
                        serviceType="common"
                        :attachList="fileList"
                        :seq="seq"
                    />

                    <dl class="attachment_link" v-if="fileList.length > 0">
                        <dt><a href="javascript:" class="txt_link" @click="toggleLink($event)">Having trouble downloading?</a></dt>
                        <dd>
                            <ul>
                                <li v-for="file in fileList" :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN">
                                    <!-- <a :href="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)" download="true" target="_blank" class="txt_link"> -->
                                    <a href="javascript:" @click="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)" class="txt_link">
                                        <span class="ico_attach"></span> {{ file.FILE_NM }}
                                    </a>
                                </li>
                            </ul>
                        </dd>
                    </dl>
                </div>

                <div class="today_wrap" v-if="mode === 'alert'">
                    <label class="checkbox-wrap">
                        <input type="checkbox" class="notice_chk" name="notice_chk" v-model="doNotDisplayToday" value />
                        <i class="check-icon"></i>
                        <em>{{$t('LABEL.NOTICE.DONTSHOWTODAY')}}</em>
                    </label>
                    <div class="item_right">
                        <a href="javascript:" class="txt_link" @click="closePopup()">
                            {{ $t('FIELD.GLOBAL.ETC.083') }}
                        </a>
                    </div>
                </div>
            </dd>
        </dl>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import moment from 'moment';
import $ from 'jquery';
import axios from 'axios';
import qs from 'query-string';

import store from '@/vuex/store';
import constants from '@/constants';
import { SDLUtil, MenuUtil, StringUtil } from '@/utils';
import { EventBus } from '@/utils/EventBus';

import InnorixDownload from '~c/InnorixDownload';

export default {
    name: 'admin-notice-view-popup',
    components: {
        'innorix-download': InnorixDownload,
    },

    props: {
        seq: {
            type: String,
            required: true,
        },
        mode: {
            type: String,
            default: 'view',
        },
    },
    data() {
        return {
            view: {
                title: '',
                description: '',
            },
            doNotDisplayToday: false,

            fileList: [],
            encToken: '',
        };
    },
    created() {
        this.init();
    },
    computed: {
        getNoticeTitle() {
            return StringUtil.nvl(this.view['title'], '');
        }
    },
    mounted() {},
    methods: {
        async init() {
            const data = await this.fetchData();
            this.setData(data);
            // this.setUserList(data.userLevelList, );
        },

        fetchData() {
            const params = {
                noticeSeq: this.seq,
            };

            const path = '/basis/admin/other/notice/NoticeDetailView.skp';
            return SDLUtil.getRequest(path, params);
        },

        setData(data) {
            this.view = data.result;
            this.view.content = StringUtil.stripHtml(data.result.content);
            this.fileList = data.attachFiles
                .map(item => {
                    // item.ENC_ATTCH_FILE_SEQ = item.attachFileSeq;
                    item.ATTCH_FILE_SEQ = item.attachFileSeq;
                    item.FILE_NM = item.fileName;
                    item.FILE_SIZE = item.fileSize;
                    return item;
                });
        },

        setAttachFiles(val) {
            Vue.$log.info('▶ InnorixDownload.vue -> NoticeViewPopup.vue / files : ', val);
            this.fileList = val.fileList || [];
            this.delAttachFiles = val.delFileList || [];
            this.isRemove = val.isRemove || false;
        },

        closePopup() {
            if (this.doNotDisplayToday) {
                // const cookieName = 'dnd-notice-popup-'+this.seq +'-'+ moment().format("YYYYMMDD")
                SDLUtil.setNoticeRead(this.seq);
            }
            this.$emit('close');
        },

        toggleLink(e) {
            $('.attachment_link > dd').toggle();
        },

        getDownloadUrl(SEQ, TOKEN) {
            const params = {
                attachFileSeq: SEQ,
                encToken: TOKEN,
                seq: this.seq,
            };

            // this.increaseHhpDownloadCount(this.view.seq);

            const downloadUrl = `${SDLUtil.API_URL}/basis/common/attachDownload.skp?${qs.stringify(params)}`;
            return window.open(downloadUrl);
        },
    },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/admin/other/NoticeViewPopup.vue